module.exports = __webpack_public_path__ + "img/logo-puebla.a8f97d72.png";